import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-plus",
  "use": "app-icon-plus-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"app-icon-plus\"><path d=\"M14 9H9v5H7V9H2V7h5V2h2v5h5v2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol